import Layout from "@/views/layout/index";

const data = [
  {
    path: "/roadFreight",
    name: "roadFreight",
    target: true,
    component: Layout,
    isChildren: true,
    hidden: true,
    meta: {title: '水路货运', icon: 'el-icon-s-help'},
    children: [
      {
        path: '/roadFreight',
        meta: {title: '信息大厅', icon: 'el-icon-s-help'},
        component: () => import('@/views/logisticscenter/roadFreight/index'),
      },
      {
        path: '/roadFreight/zxxd',
        meta: {title: '在线下单', icon: 'el-icon-s-help'},
        component: () => import('@/views/logisticscenter/roadFreight/zxxd'),
      },
      {
        path: '/roadFreight/wlgz',
        meta: {title: '物流跟踪', icon: 'el-icon-s-help'},
        component: () => import('@/views/logisticscenter/roadFreight/wlgz'),
      }
    ]
  }
]


export default data



// WEBPACK FOOTER //
// ./src/router/roadFreight.js